export { default } from 'react-bootstrap/Fade';
